<!-- Note : "modalfooter-canvasbg-gray" class is only use for temporary view perpose betterment so its not maintain the BEM structure. -->
<div class="modalfooter-canvasbg-gray">
  <div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
      <div class="flex flex-align-center">
        <a routerLink="/button" aria-label="back" class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto"
          role="button">
          <span class="u-icon icon-chevron-left"></span>
          <span class="u-button-text">Back</span>
        </a>
      </div>
      <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
        <h1 class="font-semibold u-ma-0 flex header-title--name">Modal Footer</h1>
      </div>
    </div>
    <div class="c-header__gradient"></div>
  </div>

  <h2 class="u-pa-20 u-ma-0">
    With Icons
  </h2>
  <maced-modal-footer>
    <maced-button buttonId="Action1" label="Action" color="secondary" icon="icon-plus" position="left"
      styleClass="u-button-normal"></maced-button>
    <maced-button buttonId="Action2" label="Action" color="primary" icon="icon-plus" position="right"
      styleClass="u-button-normal"></maced-button>
  </maced-modal-footer>

  <h2 class="u-pa-20 u-ma-0">
    Without Icons
  </h2>
  <maced-modal-footer>
    <maced-button buttonId="Action3" label="Acción" color="secondary" styleClass="u-button-normal"></maced-button>
    <maced-button buttonId="Action4" label="कार्य" color="primary" styleClass="u-button-normal"></maced-button>
  </maced-modal-footer>

  <h2 class="u-pa-20 u-ma-0">
    One button
  </h2>
  <maced-modal-footer>
    <maced-button buttonId="Action5" label="Next" color="primary" icon="icon-chevron-right" position="right"
      styleClass="u-button-normal"></maced-button>
  </maced-modal-footer>

  <h2 class="u-pa-20 u-ma-0">
    Deactivate
  </h2>
  <maced-modal-footer>
    <maced-button buttonId="Action6" label="Action" color="secondary" styleClass="u-button-normal" icon="icon-plus"
      position="left" [disabled]="true"></maced-button>
    <maced-button buttonId="Action7" label="Action" color="primary" styleClass="u-button-normal" icon="icon-plus"
      position="right" [disabled]="true"></maced-button>
  </maced-modal-footer>
</div>